import type { DXUserRights, SLAType } from "@/types";

export function clearLocalStorage() {
  localStorage.removeItem("prominent.session");
  localStorage.removeItem("prominent.user");
  localStorage.removeItem("prominent.user.email");
  localStorage.removeItem("prominent.user.level");
  localStorage.removeItem("prominent.access.platform");
  localStorage.removeItem("prominent.access.reports");
  localStorage.removeItem("prominent.access.multitenancy");
  localStorage.removeItem("prominent.access.im");
  localStorage.removeItem("prominent.tmp");
  localStorage.removeItem("prominent.backlink");
  localStorage.removeItem("prominent.userData");
  localStorage.removeItem("prominent.userRights");
  localStorage.removeItem("prominent.brand");
  localStorage.removeItem("prominent.theme");
  localStorage.removeItem("prominent.wlPreview");
  localStorage.removeItem("prominent.allowedMenuItems");

  console.log("clearLocalStorage --> cleared");
}

export function updateSLAStatus(key: SLAType, status: boolean) {
  const existingUserData = localStorage.getItem("prominent.userData");
  if (!existingUserData) return;

  try {
    const userData = JSON.parse(atob(existingUserData));
    userData[key] = status;

    localStorage.setItem("prominent.userData", btoa(JSON.stringify(userData)));
  } catch (error) {
    console.error("Failed to update SLA status in localStorage", error);
  }
}

export function updateTOTPStatus(totpStatus: boolean) {
  const existingUserData = localStorage.getItem("prominent.userData");
  if (existingUserData) {
    const userData = JSON.parse(atob(existingUserData));
    userData.remoteControlTOTP = totpStatus;
    localStorage.setItem("prominent.userData", btoa(JSON.stringify(userData)));
  }
}

export function parseUserRights(): DXUserRights {
  const userRightsEncoded = localStorage.getItem("prominent.userRights");
  if (userRightsEncoded === null) {
    return {};
  }

  const userRightsDecoded = atob(userRightsEncoded);
  const userRightsObject = JSON.parse(userRightsDecoded);
  return userRightsObject;
}
